// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"780":"eae9dc8f","6464":"5bb70fbb"}[chunkId] + ".chunk.css";
};